import { useMutation } from '@apollo/react-hooks'
import { CREATE_LEAD_MUTATION } from 'apollo'
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock'
import { useStoreActions } from 'hooks/useStore'
import { ComponentType, useEffect, useRef, useState } from 'react'
import usePortal from 'react-cool-portal'
import { GoX } from 'react-icons/go'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'
import { Form } from './form'
import { Thanks } from './thanks'

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #f8f9fa;
  z-index: 1030;
  overflow: auto;

  ${up('sm')} {
    top: 70px;
    right: 0;
    bottom: 0;
    left: auto;
    width: 500px;
  }
`

const CloseButton = styled.button`
  position: fixed;
  top: 16px;
  right: 16px;
  border: 0;
  background: transparent;

  ${up('sm')} {
    position: absolute;
    top: 40px;
    right: 40px;
  }
`

const Body = styled.div`
  padding: 56px 20px;

  ${up('sm')} {
    padding: 56px 76px;
  }
`

interface Props {
  agent: any
  uuid: string
  scrollLock?: boolean
}

export const Lead: ComponentType<Props> = ({ agent, uuid, scrollLock }) => {
  const [thanks, setThanks] = useState(false)
  const container = useRef<HTMLDivElement>(null)
  const setInvader = useStoreActions((actions) => actions.ui.setInvader)

  const { Portal } = usePortal({
    clickOutsideToHide: false,
    escToHide: false,
    internalShowHide: false,
  })

  const [create, { loading }] = useMutation(CREATE_LEAD_MUTATION, {
    onCompleted: () => setThanks(true),
  })

  useEffect(() => {
    if (container.current && scrollLock) disableBodyScroll(container.current)
    return clearAllBodyScrollLocks
  }, [])

  return (
    <Portal>
      <Wrapper ref={container}>
        <CloseButton type="button" onClick={() => setInvader('')}>
          <GoX color="#A2AAB4" size={20} />
        </CloseButton>
        <Body>
          {thanks ? (
            <Thanks name={`${agent.firstName} ${agent.lastName}`} thumbnailUrl={agent.avatar.thumbnailUrl} />
          ) : (
            <Form propertyId={uuid} loading={loading} onSubmit={(input) => create({ variables: { input } })} />
          )}
        </Body>
      </Wrapper>
    </Portal>
  )
}
